(function() {
  'use strict';
  if (window.__spectrumWlInit) return;
  window.__spectrumWlInit = true;

  var GUEST_KEY = '__spectrum_wishlist_guest';

  /* ── Helpers ──────────────────────────────────────────────────────────── */

  function getLib() {
    var lib = window.__spectrumAi && window.__spectrumAi.lib && window.__spectrumAi.lib.wishlist;
    return lib && typeof lib.getWishlists === 'function' ? lib : null;
  }

  function isCustomerLoggedIn() {
    return !!(window.__spectrumAi && window.__spectrumAi.customer);
  }

  function waitForLib(callback, maxRetries) {
    var retries = 0;
    maxRetries = maxRetries || 15;
    function check() {
      var lib = getLib();
      if (lib) {
        callback(lib);
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(check, 200);
      }
    }
    check();
  }

  function getGuestGids() {
    try {
      var raw = localStorage.getItem(GUEST_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed.items)
        ? parsed.items.map(function(i) { return i.shopifyProductGid; })
        : [];
    } catch(e) { return []; }
  }

  /** Unwraps getWishlists() response into a plain array of list objects */
  function extractWishlists(result) {
    if (!result.ok) return [];
    var d = result.data;
    return (d && Array.isArray(d.wishlists)) ? d.wishlists
         : (d && d.data && Array.isArray(d.data.wishlists)) ? d.data.wishlists
         : Array.isArray(d) ? d : [];
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ── Cached Wishlists (used by picker to avoid re-fetching) ── */

  var cachedWishlists = null;

  /* ── Wishlist State Sync — hydrates is-wishlisted on card buttons ── */

  function syncWishlistState() {
    if (!isCustomerLoggedIn()) return;
    waitForLib(function(lib) {
      lib.getWishlists().then(function(result) {
        var lists = extractWishlists(result);
        cachedWishlists = lists;
        var wishedGids = {};
        lists.forEach(function(l) {
          if (Array.isArray(l.items)) {
            l.items.forEach(function(item) {
              if (item.shopifyProductGid) wishedGids[item.shopifyProductGid] = true;
            });
          }
        });
        document.querySelectorAll('[data-spectrum-wishlist-btn]').forEach(function(el) {
          var gid = el.dataset.productGid;
          if (!gid) return;
          el.classList.toggle('is-wishlisted', !!wishedGids[gid]);
        });
      });
    });
  }

  /* ── Guest State Hydration ───────────────────────────────────────────── */

  function hydrateGuestState() {
    if (isCustomerLoggedIn()) return;
    var gids = getGuestGids();
    if (!gids.length) return;
    document.querySelectorAll('[data-spectrum-wishlist-btn]').forEach(function(el) {
      if (gids.indexOf(el.dataset.productGid) !== -1) {
        el.classList.add('is-wishlisted');
      }
    });
  }

  /* ── Multi-List Picker ──────────────────────────────────────────────── */

  var pickerEl = null;
  var pickerBackdrop = null;
  var pickerAnchor = null;
  var pickerGid = null;
  var pickerVariantGid = null;
  var pickerHandle = null;
  var pickerLists = [];

  function isProductInAnyList() {
    return pickerLists.some(function(list) {
      return Array.isArray(list.items) && list.items.some(function(i) {
        return i.shopifyProductGid === pickerGid;
      });
    });
  }

  function ensurePickerDOM() {
    if (pickerEl) return;

    pickerBackdrop = document.createElement('div');
    pickerBackdrop.className = 'spectrum-wl-picker-backdrop';
    document.body.appendChild(pickerBackdrop);

    pickerEl = document.createElement('div');
    pickerEl.className = 'spectrum-wl-picker';
    pickerEl.setAttribute('role', 'dialog');
    pickerEl.setAttribute('aria-label', 'Save to wishlist');
    pickerEl.innerHTML =
      '<div class="spectrum-wl-picker__header">' +
        '<span>Save to list</span>' +
        '<button type="button" class="spectrum-wl-picker__close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="spectrum-wl-picker__lists"></div>' +
      '<div class="spectrum-wl-picker__create">' +
        '<input type="text" class="spectrum-wl-picker__input" placeholder="New list name\u2026" maxlength="50" aria-label="New list name">' +
        '<button type="button" class="spectrum-wl-picker__create-btn" aria-label="Create list">+</button>' +
      '</div>';
    document.body.appendChild(pickerEl);

    pickerEl.addEventListener('change', function(e) {
      if (e.target.type === 'checkbox' && e.target.dataset.listId) {
        handleCheckboxChange(e.target);
      }
    });

    pickerEl.querySelector('.spectrum-wl-picker__close').addEventListener('click', closePicker);

    pickerEl.querySelector('.spectrum-wl-picker__create-btn').addEventListener('click', handleCreateList);

    pickerEl.querySelector('.spectrum-wl-picker__input').addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); handleCreateList(); }
    });

    pickerEl.addEventListener('click', function(e) { e.stopPropagation(); });

    pickerBackdrop.addEventListener('click', closePicker);
  }

  function openPicker(anchor, lib, gid, variantGid, handle) {
    ensurePickerDOM();

    if (pickerEl.classList.contains('is-open') && pickerAnchor === anchor) {
      closePicker();
      return;
    }

    if (pickerEl.classList.contains('is-open')) {
      closePicker();
    }

    pickerAnchor = anchor;
    pickerGid = gid;
    pickerVariantGid = variantGid;
    pickerHandle = handle;
    pickerLists = [];

    pickerEl.querySelector('.spectrum-wl-picker__input').value = '';

    positionPicker(anchor);
    pickerEl.classList.add('is-open');
    pickerBackdrop.classList.add('is-open');

    /* Use cached data if available; only fetch from API when there's no cache */
    if (cachedWishlists) {
      pickerLists = cachedWishlists;
      renderPickerLists(pickerLists, gid);
    } else {
      var listsContainer = pickerEl.querySelector('.spectrum-wl-picker__lists');
      listsContainer.innerHTML = '<div class="spectrum-wl-picker__loading"><div class="spectrum-wl-picker__spinner"></div></div>';
      lib.getWishlists().then(function(result) {
        if (!pickerEl.classList.contains('is-open') || pickerGid !== gid) return;
        pickerLists = extractWishlists(result);
        cachedWishlists = pickerLists;
        renderPickerLists(pickerLists, gid);
      });
    }
  }

  function positionPicker(anchor) {
    if (window.innerWidth < 750) {
      pickerEl.style.top = '';
      pickerEl.style.left = '';
      pickerEl.style.position = '';
      return;
    }

    var rect = anchor.getBoundingClientRect();
    var scrollY = window.scrollY || document.documentElement.scrollTop;
    var scrollX = window.scrollX || document.documentElement.scrollLeft;
    var pickerWidth = 256;
    var vpWidth = document.documentElement.clientWidth;

    var top = rect.bottom + scrollY + 8;
    var left = rect.left + scrollX + (rect.width / 2) - (pickerWidth / 2);
    if (left < 8) left = 8;
    if (left + pickerWidth > vpWidth - 8) left = vpWidth - pickerWidth - 8;

    pickerEl.style.position = 'absolute';
    pickerEl.style.top = top + 'px';
    pickerEl.style.left = left + 'px';
  }

  function renderPickerLists(lists, gid) {
    var container = pickerEl.querySelector('.spectrum-wl-picker__lists');
    if (!lists.length) {
      container.innerHTML = '<div class="spectrum-wl-picker__empty">No lists yet. Create one below.</div>';
      return;
    }

    var html = '';
    lists.forEach(function(list) {
      var isInList = Array.isArray(list.items) && list.items.some(function(i) {
        return i.shopifyProductGid === gid;
      });
      var count = list.itemCount != null ? list.itemCount : (list.items ? list.items.length : 0);
      html += '<label class="spectrum-wl-picker__item">' +
        '<input type="checkbox" data-list-id="' + escapeHtml(list.id) + '"' + (isInList ? ' checked' : '') + '>' +
        '<span class="spectrum-wl-picker__name">' + escapeHtml(list.name || 'Unnamed') + ' (' + count + ')</span>' +
        '</label>';
    });
    container.innerHTML = html;
  }

  function closePicker() {
    if (!pickerEl || !pickerEl.classList.contains('is-open')) return;
    pickerEl.classList.remove('is-open');
    pickerBackdrop.classList.remove('is-open');

    if (pickerAnchor && pickerLists.length) {
      var inAny = isProductInAnyList();
      document.querySelectorAll('[data-spectrum-wishlist-btn][data-product-gid="' + pickerGid + '"]').forEach(function(el) {
        el.classList.toggle('is-wishlisted', inAny);
      });
    }

    pickerAnchor = null;
  }

  function setItemLoading(checkbox, active) {
    var label = checkbox.closest('.spectrum-wl-picker__item');
    if (!label) return;
    if (active) {
      var spinner = document.createElement('span');
      spinner.className = 'spectrum-wl-picker__item-spinner';
      label.appendChild(spinner);
    } else {
      var existing = label.querySelector('.spectrum-wl-picker__item-spinner');
      if (existing) existing.remove();
    }
  }

  function handleCheckboxChange(checkbox) {
    var listId = checkbox.dataset.listId;
    var isChecked = checkbox.checked;
    var lib = getLib();
    if (!lib) return;

    checkbox.disabled = true;
    setItemLoading(checkbox, true);

    if (isChecked) {
      lib.addItem(listId, {
        shopifyProductGid: pickerGid,
        shopifyVariantGid: pickerVariantGid,
        handle: pickerHandle
      }).then(function(result) {
        checkbox.disabled = false;
        setItemLoading(checkbox, false);
        if (!result.ok) { checkbox.checked = false; return; }

        var list = pickerLists.find(function(l) { return l.id === listId; });
        if (list && Array.isArray(list.items)) {
          var newItem = { shopifyProductGid: pickerGid, shopifyVariantGid: pickerVariantGid, handle: pickerHandle };
          var rd = result.data;
          if (rd) newItem.id = rd.id || (rd.data && rd.data.id) || null;
          list.items.push(newItem);
          if (list.itemCount != null) list.itemCount++;
        }

        updatePickerItemCount(listId);
        document.dispatchEvent(new CustomEvent('spectrum:wishlist:updated', {
          detail: { action: 'added', productGid: pickerGid, isInAnyList: isProductInAnyList() }
        }));
      });
    } else {
      var list = pickerLists.find(function(l) { return l.id === listId; });
      var item = list && Array.isArray(list.items) && list.items.find(function(i) {
        return i.shopifyProductGid === pickerGid;
      });

      if (!item) {
        checkbox.checked = true;
        checkbox.disabled = false;
        return;
      }

      /* Use targeted removeItem if item ID exists, otherwise fall back to removeByProduct */
      var removeCall = item.id
        ? lib.removeItem(listId, item.id)
        : lib.removeByProduct(pickerGid);

      removeCall.then(function(result) {
        checkbox.disabled = false;
        setItemLoading(checkbox, false);
        if (!result.ok) { checkbox.checked = true; return; }

        if (item.id) {
          /* Targeted: only this list affected */
          if (list && Array.isArray(list.items)) {
            list.items = list.items.filter(function(i) { return i.shopifyProductGid !== pickerGid; });
            if (list.itemCount != null && list.itemCount > 0) list.itemCount--;
          }
          updatePickerItemCount(listId);
        } else {
          /* removeByProduct removes from ALL lists — update all local caches */
          pickerLists.forEach(function(l) {
            if (Array.isArray(l.items)) {
              var before = l.items.length;
              l.items = l.items.filter(function(i) { return i.shopifyProductGid !== pickerGid; });
              var removed = before - l.items.length;
              if (l.itemCount != null) l.itemCount = Math.max(0, l.itemCount - removed);
            }
          });
          renderPickerLists(pickerLists, pickerGid);
        }

        document.dispatchEvent(new CustomEvent('spectrum:wishlist:updated', {
          detail: { action: 'removed', productGid: pickerGid, isInAnyList: isProductInAnyList() }
        }));
      });
    }
  }

  function updatePickerItemCount(listId) {
    if (!pickerEl) return;
    var list = pickerLists.find(function(l) { return l.id === listId; });
    if (!list) return;
    var count = list.itemCount != null ? list.itemCount : (list.items ? list.items.length : 0);
    var checkbox = pickerEl.querySelector('input[data-list-id="' + listId + '"]');
    if (!checkbox) return;
    var nameEl = checkbox.parentNode.querySelector('.spectrum-wl-picker__name');
    if (nameEl) {
      nameEl.textContent = (list.name || 'Unnamed') + ' (' + count + ')';
    }
  }

  function handleCreateList() {
    var input = pickerEl.querySelector('.spectrum-wl-picker__input');
    var name = input.value.trim();
    if (!name) return;

    var lib = getLib();
    if (!lib) return;

    var btn = pickerEl.querySelector('.spectrum-wl-picker__create-btn');
    input.disabled = true;
    btn.disabled = true;

    lib.createWishlist(name).then(function(result) {
      input.disabled = false;
      btn.disabled = false;
      if (!result.ok) return;

      var newList = result.data;
      if (newList && newList.data) newList = newList.data;
      if (newList && newList.wishlist) newList = newList.wishlist;
      if (!newList || !newList.id) return;

      if (!newList.name) newList.name = name;
      if (!Array.isArray(newList.items)) newList.items = [];
      if (newList.itemCount == null) newList.itemCount = 0;

      pickerLists.push(newList);

      lib.addItem(newList.id, {
        shopifyProductGid: pickerGid,
        shopifyVariantGid: pickerVariantGid,
        handle: pickerHandle
      }).then(function(addResult) {
        if (addResult.ok) {
          var newItem = { shopifyProductGid: pickerGid, shopifyVariantGid: pickerVariantGid, handle: pickerHandle };
          var rd = addResult.data;
          if (rd) newItem.id = rd.id || (rd.data && rd.data.id) || null;
          newList.items.push(newItem);
          newList.itemCount++;
        }

        renderPickerLists(pickerLists, pickerGid);
        input.value = '';
        document.dispatchEvent(new CustomEvent('spectrum:wishlist:updated', {
          detail: { action: 'added', productGid: pickerGid, isInAnyList: true }
        }));
      });
    });
  }

  /* ── Click Handler (delegated) ───────────────────────────────────────── */

  document.addEventListener('click', function(e) {
    var wrapper = e.target.closest('[data-spectrum-wishlist-btn]');
    if (!wrapper || wrapper.classList.contains('is-processing')) return;

    e.preventDefault();
    e.stopPropagation();

    var lib = getLib();
    if (!lib) return;

    var gid = wrapper.dataset.productGid;
    var variantGid = wrapper.dataset.variantGid || null;
    var handle = wrapper.dataset.productHandle || '';

    /* Logged-in users: open multi-list picker */
    if (isCustomerLoggedIn()) {
      openPicker(wrapper, lib, gid, variantGid, handle);
      return;
    }

    /* Guest users: single-toggle behavior (unchanged) */
    var isWishlisted = wrapper.classList.contains('is-wishlisted');

    wrapper.classList.add('is-processing');
    wrapper.classList.toggle('is-wishlisted');

    var btnEl = wrapper.querySelector('button');
    if (btnEl) {
      btnEl.disabled = true;
      var newLabel = isWishlisted ? 'Add to wishlist' : 'Remove from wishlist';
      btnEl.setAttribute('aria-label', newLabel);
      btnEl.setAttribute('title', newLabel);
    }

    var apiCall = isWishlisted
      ? lib.removeByProduct(gid)
      : lib.addItem('default', { shopifyProductGid: gid, shopifyVariantGid: variantGid, handle: handle });
    var minDelay = new Promise(function(r) { setTimeout(r, 300); });

    Promise.all([apiCall, minDelay]).then(function(results) {
      var result = results[0];
      wrapper.classList.remove('is-processing');
      if (btnEl) btnEl.disabled = false;

      if (!result.ok) {
        wrapper.classList.toggle('is-wishlisted');
        if (btnEl) {
          var revertLabel = isWishlisted ? 'Remove from wishlist' : 'Add to wishlist';
          btnEl.setAttribute('aria-label', revertLabel);
          btnEl.setAttribute('title', revertLabel);
        }
        return;
      }

      document.dispatchEvent(new CustomEvent('spectrum:wishlist:updated', {
        detail: { action: isWishlisted ? 'removed' : 'added', productGid: gid }
      }));
    });
  });

  /* ── Picker Close Events ─────────────────────────────────────────────── */

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && pickerEl && pickerEl.classList.contains('is-open')) {
      closePicker();
    }
  });

  document.addEventListener('click', function(e) {
    if (!pickerEl || !pickerEl.classList.contains('is-open')) return;
    if (e.target.closest('[data-spectrum-wishlist-btn]')) return;
    if (e.target.closest('.spectrum-wl-picker')) return;
    closePicker();
  });

  /* ── Cross-Component Sync ────────────────────────────────────────────── */

  function updateHeaderCount(delta) {
    document.querySelectorAll('.m-wishlist-count').forEach(function(el) {
      var current = parseInt(el.textContent, 10) || 0;
      var next = Math.max(0, current + delta);
      el.textContent = next;
      el.classList.toggle('m:hidden', next === 0);
    });
  }

  document.addEventListener('spectrum:wishlist:updated', function(e) {
    var detail = e.detail || {};
    document.querySelectorAll('[data-spectrum-wishlist-btn][data-product-gid="' + detail.productGid + '"]').forEach(function(el) {
      if (detail.isInAnyList !== undefined) {
        el.classList.toggle('is-wishlisted', detail.isInAnyList);
      } else if (detail.action === 'added') {
        el.classList.add('is-wishlisted');
      } else if (detail.action === 'removed') {
        el.classList.remove('is-wishlisted');
      }
    });

    if (detail.action === 'added') updateHeaderCount(1);
    else if (detail.action === 'removed') updateHeaderCount(-1);

    syncWishlistState();
  });

  /* ── Init ─────────────────────────────────────────────────────────────── */

  function init() {
    hydrateGuestState();
    syncWishlistState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
